import React, { useState } from "react";
import { motion } from "framer-motion";

function Content({ data, disabled, isExpanded }) {
  return (
    <motion.div
      style={{ opacity: disabled ? 0.5 : 1 }}
      className={`z-1 h-auto w-full flex shrink-0 ${
        isExpanded ? "flex-col mt-4" : "flex-col hover:scale-105 mt-0"
      } transition-all duration-300 ease cursor-pointer justify-start items-start group relative`}
    >
      <img
        src={data.image}
        alt={data.name}
        className={`${
          isExpanded
            ? "hover:shadow-none md:w-80 w-full"
            : "hover:shadow-xl shadow-darkblue/10 w-full"
        } flex shrink-0 transition-all duration-300 ease 2xl:h-56 4xl:h-72 ${
          isExpanded ? "md:h-72 h-40" : "md:h-52 h-40"
        } object-cover object-center rounded-xl`}
      />

      <div
        className={`flex flex-col ${isExpanded ? "pl-0 mt-4" : "pl-0 mt-0"}`}
      >
        <h3
          className={`text-head font-bold 4xl:text-2xl text-base ${
            isExpanded ? "mt-0 lg:text-lg md:text-xl" : "mt-2 lg:text-lg"
          } `}
        >
          {data.name}
        </h3>
        <p
          className={`${
            isExpanded ? "lg:text-md text-xs" : "text-sm"
          } text-black/80 font-semibold`}
        >
          {data.title}
        </p>

        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, top: "-6rem" }}
            animate={{ opacity: 1, top: "0rem" }}
            className={`mt-2 overflow-y-auto leading-tight text-left w-full md:text-sm text-xs`}
            style={{ color: "#616161" }}
          >
            {data.description}
          </motion.div>
        )}
      </div>
    </motion.div>
  );
}

function ExpandedCard({ children, onCollapse }) {
  return (
    <>
      <motion.div
        className="md:w-[60vw] w-[90vw] md:max-h-[80vh] max-h-[95vh] fixed shadow-4xl flex md:top-[15vh] top-[15vh] shadow-2xl md:left-[20vw] left-[5vw] bg-white z-100 md:p-8 p-6"
        layoutId="expandable-card"
      >
        {children}
        <div
          className="absolute top-4 right-8 cursor-pointer"
          onClick={onCollapse}
        >
          <img src="/images/icons/cancel.png" alt="close" className="w-8" />
        </div>
      </motion.div>
    </>
  );
}

function CompactCard({ children, onExpand, disabled }) {
  return (
    <motion.div
      className="w-full bg-transparent z-0"
      layoutId="expandable-card"
      onClick={!disabled ? onExpand : undefined}
    >
      {children}
    </motion.div>
  );
}

function MemberBlock({ data, onCollapse, onExpand, disabled }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const collapseMember = () => {
    setIsExpanded(false);
    onCollapse();
    document.body.style.overflow = "unset";
  };

  const expandMember = () => {
    if (typeof window !== "undefined") {
      document.body.style.overflow = "hidden";
    }
    setIsExpanded(true);
    onExpand();
  };

  return (
    <div className="w-full">
      {isExpanded ? (
        <ExpandedCard onCollapse={collapseMember}>
          <Content disabled={disabled} isExpanded={isExpanded} data={data} />
        </ExpandedCard>
      ) : (
        <CompactCard onExpand={expandMember} disabled={disabled}>
          <Content disabled={disabled} isExpanded={isExpanded} data={data} />
        </CompactCard>
      )}
    </div>
  );
}

export default function ExpandBox({ data }) {
  const [expandedMember, setExpandedMember] = useState();

  return (
    <MemberBlock
      data={data}
      disabled={expandedMember !== data.id && expandedMember !== undefined}
      onExpand={() => setExpandedMember(data.id)}
      onCollapse={() => setExpandedMember(undefined)}
    />
  );
}
